// 工信部 ICP 备案悬挂组件
// 合规要求（阿里云/工信部核查）：网站底部展示网站备案号，并链接至工信部备案系统 beian.miit.gov.cn
// 备案主体：贵州黔好运数智物流科技有限公司 ｜ 域名：gzhdsd.com
export const ICP_NUMBER = '黔ICP备2026014296号-1';
export const ICP_URL = 'https://beian.miit.gov.cn/';

export default function IcpFooter({ dark = false, style = {} }) {
  const color = dark ? 'rgba(255,255,255,0.75)' : 'rgba(0,0,0,0.45)';
  return (
    <div style={{ textAlign: 'center', padding: '10px 0 14px', fontSize: 12, lineHeight: '20px', color, ...style }}>
      <a
        href={ICP_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'inherit', textDecoration: 'none' }}
      >
        {ICP_NUMBER}
      </a>
    </div>
  );
}
